// extracted by mini-css-extract-plugin
export default {"resourceCheckWarningContainer":"ResourceCheckWarning--resourceCheckWarningContainer--1ab9c4"};